import { trans, transChoice } from '@lingoda/i18n';
import hiddenPrizeIcon from '../assets/icons/hidden-prize-200.svg?url';

interface Params {
    challengeName: string;
    prizeValue: number;
}

export const getChallengePrizeAchievedNotificationContent = ({
    challengeName,
    prizeValue,
}: Params) => {
    const description = transChoice(
        'activity-challenge-notification-description',
        prizeValue,
        { activitiesCount: prizeValue },
        'student-challenges',
    );
    const iconUrl = hiddenPrizeIcon;

    switch (challengeName) {
        case 'may-2024': {
            return {
                header: trans('may-2024-title', {}, 'student-challenges'),
                description,
                iconUrl,
            };
        }
        case 'april-2024': {
            return {
                header: trans('april-2024-title', {}, 'student-challenges'),
                description,
                iconUrl,
            };
        }
        case 'march-2024': {
            return {
                header: trans('march-2024-title', {}, 'student-challenges'),
                description,
                iconUrl,
            };
        }
        case 'february-2024': {
            return {
                header: trans('february-2024-title', {}, 'student-challenges'),
                description,
                iconUrl,
            };
        }
        case 'january-2024': {
            return {
                header: trans('january-2024-title', {}, 'student-challenges'),
                description,
                iconUrl,
            };
        }
        case 'december-2023': {
            return {
                header: trans('december-2023-title', {}, 'student-challenges'),
                description,
                iconUrl,
            };
        }
        default: {
            return {
                header: '',
                description,
                iconUrl,
            };
        }
    }
};
